'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = proxy;

var _constants = require('./constants');

var _transfer = require('./transfer');

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var proxies = new WeakMap();

/**
 * Proxies an object inside an worker.
 * This should be called inside an worker.
 */
function proxy(o) {
  var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : self;

  if (proxies.has(target)) {
    throw new Error('The specified target already has a proxy. To create a new proxy, call `dispose` first to dispose the previous proxy.');
  }

  proxies.set(target, true);

  // List of persisted function refs
  var persisted = [];

  // Listen to messages from the client
  var listener = function listener(e) {
    switch (e.data.type) {
      case _constants.ACTION_OPERATION:
        {
          (function () {
            var _e$data = e.data,
                id = _e$data.id,
                data = _e$data.data;


            try {
              var result = o;

              var _iteratorNormalCompletion = true;
              var _didIteratorError = false;
              var _iteratorError = undefined;

              try {
                for (var _iterator = data[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  var action = _step.value;

                  if (action.type === 'get') {
                    result = result[action.key];
                  } else if (action.type === 'set') {
                    // Reflect.set will return a boolean to indicate if setting the property was successful
                    // Setting the property might fail if the object is read only
                    result = Reflect.set(result, action.key, (0, _transfer.deserialize)(action.value));
                  } else if (action.type === 'apply') {
                    var prop = result[action.key];

                    if (typeof prop !== 'function') {
                      throw new TypeError(action.key + ' is not a function');
                    } else {
                      result = prop.apply(undefined, _toConsumableArray(action.args.map(function (arg) {
                        if (arg != null && arg.type === _constants.TYPE_FUNCTION) {
                          // If we find a ref for a function, replace it with a custom function
                          // This function can notify the parent when it receives arguments
                          return function () {
                            var called = false;

                            if (arg.persisted) {
                              // If the function is persisted, add it to the persisted list
                              persisted.push(arg.ref);
                            }

                            return function () {
                              for (var _len = arguments.length, params = Array(_len), _key = 0; _key < _len; _key++) {
                                params[_key] = arguments[_key];
                              }

                              if (called && !persisted.includes(arg.ref)) {
                                // If function was called before and is no longer persisted, don't send results back
                                throw new Error(_constants.MESSAGE_DISPOSED_ERROR);
                              }

                              called = true;
                              target.postMessage({
                                type: _constants.RESULT_CALLBACK,
                                id: id,
                                func: {
                                  args: params.map(_transfer.serialize),
                                  ref: arg.ref
                                }
                              });
                            };
                          }();
                        }

                        return (0, _transfer.deserialize)(arg);
                      })));
                    }
                  } else {
                    throw new Error('Unsupported operation "' + action.type + '"');
                  }
                }

                // If result is a thenable, resolve the result before sending
                // This allows us to support results which are promise-like
                /* $FlowFixMe */
              } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                  }
                } finally {
                  if (_didIteratorError) {
                    throw _iteratorError;
                  }
                }
              }

              if (result && typeof result.then === 'function') {
                Promise.resolve(result).then(function (r) {
                  return target.postMessage({
                    type: _constants.RESULT_SUCCESS,
                    id: id,
                    result: (0, _transfer.serialize)(r)
                  });
                }, function (e) {
                  return target.postMessage({
                    type: _constants.RESULT_ERROR,
                    id: id,
                    error: (0, _transfer.serialize)(e)
                  });
                });
              } else {
                target.postMessage({
                  type: _constants.RESULT_SUCCESS,
                  id: id,
                  result: (0, _transfer.serialize)(result)
                });
              }
            } catch (e) {
              target.postMessage({
                type: _constants.RESULT_ERROR,
                id: id,
                error: (0, _transfer.serialize)(e)
              });
            }
          })();
        }

        break;

      case _constants.ACTION_DISPOSE:
        {
          // Remove the callback ref from persisted list when it's disposed
          var index = persisted.indexOf(e.data.ref);

          if (index > -1) {
            persisted.splice(index, 1);
          }
        }

        break;
    }
  };

  target.addEventListener('message', listener);

  return {
    // Return a method to dispose the proxy
    // Disposing will remove the listeners and the proxy will stop working
    dispose: function dispose() {
      target.removeEventListener('message', listener);
      proxies.delete(target);
    }
  };
}
//# sourceMappingURL=proxy.js.map